import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datatableFilterNameDisplay',
  standalone: true
})
export class DatatableFilterNameDisplayPipe implements PipeTransform {

  transform(value: string, array: { value: string, name: string }[]): string {

    if (!value || !array || !Array.isArray(array)) {
      return 'No data';
    }

    const foundItem = array.find(item => item.value === value);

    return foundItem ? foundItem.name : value;
  }

}
